<template>
    <Row :gutter="16" class="tw-mb-4">
        <Col :span="5">
            <Card class="summary-card tw-shadow-md tw-h-full">
                <div class="tw-p-4 tw-h-full tw-flex tw-flex-col tw-justify-between">
                    <div class="tw-flex tw-items-center tw-justify-between">
                        <div>
                            <div class="tw-text-gray-500 tw-text-xs tw-uppercase tw-font-semibold tw-mb-2">Total COs</div>
                            <div class="tw-text-3xl tw-font-bold tw-text-blue-600 tw-mb-2">{{ totalCOs }}</div>
                            <div class="tw-text-xs tw-text-gray-400">Collection Officers</div>
                        </div>
                        <div class="tw-bg-blue-100 tw-rounded-full tw-p-3 tw-flex-shrink-0">
                            <Icon type="ios-people" size="28" class="tw-text-blue-600" />
                        </div>
                    </div>
                </div>
            </Card>
        </Col>
        
        <Col :span="6">
            <Card class="summary-card tw-shadow-md tw-h-full">
                <div class="tw-p-4 tw-h-full tw-flex tw-flex-col tw-justify-between">
                    <div class="tw-flex tw-items-center tw-justify-between">
                        <div>
                            <div class="tw-text-gray-500 tw-text-xs tw-uppercase tw-font-semibold tw-mb-2">Total Disbursed</div>
                            <div class="tw-text-2xl tw-font-bold tw-text-green-600 tw-mb-2">{{ formatNumber(summary.disbursed_amount) }}</div>
                            <div class="tw-text-xs tw-text-gray-400">Loan Amount</div>
                        </div>
                        <div class="tw-bg-green-100 tw-rounded-full tw-p-3 tw-flex-shrink-0">
                            <Icon type="ios-cash" size="28" class="tw-text-green-600" />
                        </div>
                    </div>
                </div>
            </Card>
        </Col>
        
        <Col :span="6">
            <Card class="summary-card tw-shadow-md tw-h-full">
                <div class="tw-p-4 tw-h-full tw-flex tw-flex-col tw-justify-between">
                    <div class="tw-flex tw-items-center tw-justify-between">
                        <div>
                            <div class="tw-text-gray-500 tw-text-xs tw-uppercase tw-font-semibold tw-mb-2">Total Collected</div>
                            <div class="tw-text-2xl tw-font-bold tw-text-purple-600 tw-mb-2">{{ formatNumber(summary.actual_collected) }}</div>
                            <div class="tw-text-xs tw-text-gray-400">Repayment Amount</div>
                        </div>
                        <div class="tw-bg-purple-100 tw-rounded-full tw-p-3 tw-flex-shrink-0">
                            <Icon type="ios-card" size="28" class="tw-text-purple-600" />
                        </div>
                    </div>
                </div>
            </Card>
        </Col>
        
        <Col :span="7">
            <Card class="summary-card tw-shadow-md tw-h-full">
                <div class="tw-p-4 tw-h-full">
                    <div class="tw-flex tw-items-center tw-justify-between tw-h-full">
                        <div class="tw-flex tw-items-center tw-flex-1">
                            <div class="tw-bg-orange-100 tw-rounded-full tw-p-3 tw-mr-3">
                                <Icon type="ios-wallet" size="24" class="tw-text-orange-600" />
                            </div>
                            <div>
                                <div class="tw-text-gray-500 tw-text-xs tw-uppercase tw-font-semibold tw-mb-1">Cash</div>
                                <div class="tw-text-lg tw-font-bold tw-text-orange-600">{{ formatNumber(summary.cash_khr, '៛') }}</div>
                                <div class="tw-text-base tw-font-semibold tw-text-orange-500">{{ formatNumber(summary.cash_usd, '$') }}</div>
                            </div>
                        </div>
                        <div class="tw-h-16 tw-w-px tw-bg-gray-300 tw-mx-4"></div>
                        <div class="tw-flex tw-items-center tw-flex-1">
                            <div class="tw-bg-indigo-100 tw-rounded-full tw-p-3 tw-mr-3">
                                <Icon type="md-card" size="24" class="tw-text-indigo-600" />
                            </div>
                            <div>
                                <div class="tw-text-gray-500 tw-text-xs tw-uppercase tw-font-semibold tw-mb-1">Bank</div>
                                <div class="tw-text-lg tw-font-bold tw-text-indigo-600">{{ formatNumber(summary.bank_khr, '៛') }}</div>
                                <div class="tw-text-base tw-font-semibold tw-text-indigo-500">{{ formatNumber(summary.bank_usd, '$') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        </Col>
    </Row>
</template>

<script>
export default {
    name: 'SummaryCards',
    props: {
        totalCOs: {
            type: Number,
            required: true
        },
        summary: {
            type: Object,
            required: true
        }
    },
    methods: {
        formatNumber(num, currency = "") {
            if ((!num && num !== 0) || num === 0) return currency ? `${currency} -` : "-";
            let val = new Intl.NumberFormat("en-US", { 
                minimumFractionDigits: currency === "$" ? 2 : 0, 
                maximumFractionDigits: 2 
            }).format(num);
            return currency ? `${currency} ${val}` : val;
        }
    }
};
</script>

<style scoped>
.summary-card { 
    transition: all 0.3s ease; 
}
.summary-card:hover { 
    transform: translateY(-2px); 
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important; 
}
</style>
